import { PropsWithChildren } from 'react'
import styled from 'styled-components'

const DesktopWrapper = ({ children }: PropsWithChildren<{}>) => {
  return <Container>{children}</Container>
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.color.neutral.color7};
  border-radius: 16px;
  padding: 16px;
  background-color: ${({ theme }) => theme.color.neutral.color10};
  ${({ theme }) => theme.mediaQueries.tabletDown} {
    flex-wrap: wrap;
  }
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    display: none;
  }
`

export default DesktopWrapper
